export const ESchoolStrokeColor = "rgb(255, 225, 0)";
export const JSchoolStrokeColor = "rgb(0, 150, 255)";
export const ESchoolFillColor = "rgb(255, 225, 0)";
export const JSchoolFillColor = "rgb(0, 200, 255)";

export const minTsuboAreaForCalcUnitPrice = 25;
export const maxTsuboAreaForCalcUnitPrice = 90;
